
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';

import HomeSupportSection from 'components/HomeSupportSection';
// import { SupportButton } from 'components/HomeSupportSection';

import useUserIdentity from 'hooks/useUserIdentity';
import useRoles from 'hooks/useRoles';

const SupportStaffHome = () => {
    const url = "https://docs.google.com/document/d/1ZljF6MR44_ie6Y-ZimfGgCnLAZapK40Ntok5IbLarFw/edit?usp=sharing"
    return (
        <Stack spacing={1} m={1}>

            <Stack direction="row"
                alignItems="center">
                <Typography level="title-md">Let's help some people</Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
                <Tooltip title="Open the Suport Team handbook">
                    <Typography level="title-sm">
                        <a target="_blank" href={url}>🧰 Support Handbook</a>
                    </Typography>
                </Tooltip>
            </Stack>


            <HomeSupportSection />
        </Stack >
    );
}



const SupportDashboard = observer(() => {

    const { currentIdentity } = useUserIdentity();
    const { rolesNames } = useRoles();

    const isSupportStaff = currentIdentity.role == 'assistant' && rolesNames.includes('support');
    if (!isSupportStaff) return null;

    return <SupportStaffHome />
});



export default SupportDashboard;
